import React, { useCallback, useMemo } from 'react';
import { MultiTabMenu } from 'components/menus/MultiTabMenu';
import { BookingHistoryFiltersAndExport } from '../BookingHistoryFiltersAndExport';
import { DateSelectionSection } from '../DateSelectionSection';

export function BookResourceAndBookingExportSection({ laundryResources }) {

  const BookResourceTab = useCallback(
    () => (
      <DateSelectionSection
        laundryResources={laundryResources}
      />
    ),
    [laundryResources],
  );

  const BookingHistoryTab = useCallback(
    () => <BookingHistoryFiltersAndExport />,
    [],
  );

  const tabs = useMemo(() => ({
    bookAResource: {
      title: '',
      component: BookResourceTab,
      menus: [],
    },
    bookingHistory: {
      title: '',
      component: BookingHistoryTab,
      menus: [],
    },
  }), [BookResourceTab, BookingHistoryTab]);

  return (
    <MultiTabMenu
      title="laundryBrikk"
      defaultTab="bookAResource"
      tabs={tabs}
      showOr={false}
    />
  );
}
